export default (route: string): string =>`${location.origin}/${route}`;